import { render } from "./Dashboard.vue?vue&type=template&id=7d34b0a1"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"
script.render = render

export default script